module.exports = __webpack_public_path__ + "img/TE-Lockup-RGB-WHITE.67081df8.svg";